import { useContext } from 'react'

import { PrinterContext, PrinterCtx } from 'src/components/data/providers/PrinterProvider'

const usePrinter = (): PrinterCtx => useContext(PrinterContext)

export default usePrinter
